<template>
  <router-link
    to="/main/daka_action"
    tag="div"
    v-if="has_clock > 0"
    class="daka_index_btn"
  >
    <!-- <img src="@/assets/img/daka/daka_icon.png" class="clock-in"> -->
    <img src="@/assets/img/daka/daka_icon2.png" class="clock-in" />
    <p>{{ $t("index.signin") }}</p>
    <div class="red_point"></div>
  </router-link>
</template>
<script>
export default {
  data() {
    return {
      has_clock: null,
    };
  },
  created() {
    this.init();
  },
  activated() {
    if (this.has_clock != null) {
      this.init();
    }
  },
  methods: {
    init() {
      let _this = this;
      let url = "index.php/mobile/user-follow-up/get-count";
      let params = {
        size: 5,
        type: 0,
        sys_id: localStorage.getItem("_sys_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        user_id: localStorage.getItem("_user_data_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        language: localStorage.getItem("_user_data_language"),
      };
      _this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          _this.has_clock = parseInt(res.data.result.count.goingCnt);
          if (parseInt(res.data.result.count.goingCnt) > 0) {
            localStorage.setItem(
              "has_clock",
              parseInt(res.data.result.count.goingCnt)
            );
          } else {
            localStorage.setItem("has_clock", 0);
          }
        } else {
          // //_this.$message.error("数据异常");
          //_this.$message.error(_this.$t("public.DataError"));
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.clock-in {
  position: relative;
  width: 1.1rem;
  height: 1.14rem;
}

.red_point {
  position: absolute;
  left: 0.06rem;
  top: 0.06rem;
  width: 0.2rem;
  height: 0.2rem;
  background: #f75d5d;
  border: 0.04rem solid #fff;
  border-radius: 50%;
}

p {
  position: absolute;
  right: 0.1rem;
  bottom: 0.12rem;
  width: 1.1rem;
  text-align: right;
  // text-align:center;
  color: #fff;
  font-size: 0.2rem;
}
</style>
